import { createProvider } from '@nvision/services/data-provider';

import type { CarrierCodeFilters } from '../../models';
import * as api from './api';
import { normalizeCarrierCodeFilters, normalizeCarrierCodes } from './normalize';

export const fetchCarrierCodes = createProvider(
  (filters: Partial<CarrierCodeFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchCarrierCodes(normalizeCarrierCodeFilters(filters), { signal }),
).andThen((res) => normalizeCarrierCodes(res));
